import home from "../Images/Assets/assets6.jpeg"
import n1 from "../Images/Assets/Incubation.jpg"
import n2 from "../Images/Assets/Anganwadis.jpeg"
import n3 from "../Images/Assets/spellstrikers.jpeg"
import Marketathon from './Assets/banner-bg.jpg'; 




export default { home, n1, n2,n3,Marketathon, }
